const storeTypes = {
  PARTNER_AS_POA:"PARTNER_AS_POA",
  SET_EXECUTOR:'SET POA EXECUTOR',
  SET_COEXECUTOR:'SET POA CO_EXECUTOR',
  SET_ALT_EXECUTOR:'SET POA ALT EXECUTOR',
}
export default storeTypes;